import { Font } from '@react-pdf/renderer';
import FontPoppinsBold from '../views/Report/Pdf/fonts/Poppins-Bold.ttf';
import FontPoppinsBoldItalic from '../views/Report/Pdf/fonts/Poppins-BoldItalic.ttf';
import FontPoppinsRegular from '../views/Report/Pdf/fonts/Poppins-Regular.ttf';
import FontLatoBlack from '../views/Report/Pdf/fonts/Lato-Black.ttf';
import FontLatoBold from '../views/Report/Pdf/fonts/Lato-Bold.ttf';

const registerFonts = () => {
  Font.register({
    family: 'Poppins',
    fonts: [
      { src: FontPoppinsRegular, fontStyle: 'normal' },
      { src: FontPoppinsBold, fontStyle: 'bold' },
      { src: FontPoppinsBoldItalic, fontStyle: 'italic' },
    ],
  });
  Font.register({
    family: 'Lato',
    fonts: [
      { src: FontLatoBlack, fontStyle: 'normal' },
      { src: FontLatoBold, fontStyle: 'bold' },
    ],
  });
};

// react-pdf hyphenates with English patterns, which splits Romanian words in
// the wrong places ("dumneav-oastră"); Romanian text wraps on whole words.
// Without a callback react-pdf uses its default English engine.
const wholeWords = (word: string) => [word];
const englishHyphenation = undefined as unknown as typeof wholeWords;

export const setPdfHyphenation = (language: string) =>
  Font.registerHyphenationCallback(
    language === 'ro' ? wholeWords : englishHyphenation
  );

export default registerFonts;
